import {isProdEnvironment} from '/util/env.util';

export const ENABLE_TESTING_OPTIONS = !isProdEnvironment();
